import { render, staticRenderFns } from "./ColorQuantitySelector.vue?vue&type=template&id=0ec28853&scoped=true"
import script from "./ColorQuantitySelector.vue?vue&type=script&lang=ts"
export * from "./ColorQuantitySelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec28853",
  null
  
)

export default component.exports